"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pclnDesignSystem = require("pcln-design-system");

var _LinkButton = _interopRequireDefault(require("../../navigation/LinkButton"));

var _Dialog = _interopRequireDefault(require("../Dialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InfoDialog = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      title = _ref.title,
      buttonText = _ref.buttonText,
      scrollLockHelper = _ref.scrollLockHelper,
      children = _ref.children,
      linkColor = _ref.linkColor;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      onIsOpenClick = _useState2[1];

  var onOpen = function onOpen() {
    onIsOpenClick(true);

    if (scrollLockHelper) {
      scrollLockHelper.on();
    }
  };

  var onClose = function onClose() {
    onIsOpenClick(false);

    if (scrollLockHelper) {
      scrollLockHelper.off();
    }
  };

  return _react["default"].createElement(_pclnDesignSystem.Flex, {
    className: className
  }, _react["default"].createElement(_LinkButton["default"], {
    onClick: onOpen,
    color: linkColor,
    fontSize: 1
  }, buttonText), _react["default"].createElement(_Dialog["default"], {
    isOpen: isOpen,
    onClose: onClose,
    title: title
  }, children));
});
InfoDialog.displayName = 'InfoDialog';
InfoDialog.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  buttonText: _propTypes["default"].node,
  children: _propTypes["default"].node.isRequired,
  scrollLockHelper: _propTypes["default"].object,
  linkColor: _propTypes["default"].string
};
InfoDialog.defaultProps = {
  className: '',
  linkColor: 'secondary'
};
var _default = InfoDialog;
exports["default"] = _default;